import React, { Fragment } from 'react'
import Header from '../components/layouts/Header'
import Footer from '../components/layouts/Footer'
import { useSelector } from 'react-redux'
import StepOneForm from '../features/findJobs/StepOneForm';
import StepTwoForm from '../features/findJobs/StepTwoForm';
import StepThreeForm from '../features/findJobs/StepThreeForm';
import StepFourForm from '../features/findJobs/StepFourForm';
import StepFiveForm from '../features/findJobs/StepFiveForm';
import StepSixForm from '../features/findJobs/StepSixForm';
import StepSevenForm from '../features/findJobs/StepSevenForm';
import StepEightForm from '../features/findJobs/StepEightForm';
import CodingBackground from '../assets/common/CodingBackground.png';
import SuccessModal from '../features/findJobs/SuccessModal';
import { setShowSuccessModal } from '../redux/slice/commonSlice';
import { useDispatch } from 'react-redux';
import PreviouslyRockedAt from '../features/common/PreviouslyRockedAt';
import { useNavigate } from 'react-router-dom';
import { setFormStep } from '../redux/slice/findJobSlice';
import useDocumentTitle from '../hooks/useDocumentTitle';

const FindJobsPage = () => {
    useDocumentTitle("Find Jobs");

    const backgroundStyle = {
        backgroundImage: `url(${CodingBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
    }
    
    const step = useSelector(state => state.findJob.step);
    const showSuccessModal = useSelector(state => state.common.showSuccessModal);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    
    const handleSuccessModalClose = () => {
        dispatch(setShowSuccessModal(false));
        dispatch(setFormStep(1));
        
        setTimeout(() => {
            navigate('/');
        }, 1000);
    }
    return (
        <Fragment>
            <Header />

            <div style={backgroundStyle}>
                <div className='text-white --layout-padding max-width'>
                    {step === 1 && <StepOneForm />}
                    {step === 2 && <StepTwoForm />}
                    {step === 3 && <StepThreeForm />}
                    {step === 4 && <StepFourForm />}
                    {step === 5 && <StepFiveForm />}
                    {step === 6 && <StepSixForm />}
                    {step === 7 && <StepSevenForm />}
                    {step === 8 && <StepEightForm />}
                </div>
            </div>
            
            <PreviouslyRockedAt />

            <SuccessModal show={showSuccessModal} onClose={handleSuccessModalClose} />
            <Footer />
        </Fragment>
    )
}

export default FindJobsPage;